import { Button, Group } from '@mantine/core';

import { ProvidedDocuments } from '@e-origin/shared';

import { Table } from '@components';
import { useSendProvidedDocuments } from '@hooks/declaration/send';

interface ConfirmSendProvidedDocumentsProps {
  documents: ProvidedDocuments[];
  declarationId: string;
  onHide: () => void;
}

export const ConfirmSendProvidedDocuments = ({ documents, declarationId, onHide }: ConfirmSendProvidedDocumentsProps) => {
  const { mutate, isPending } = useSendProvidedDocuments();

  const handleConfirmSend = () => {
    mutate({ declarationId }, { onSuccess: onHide });
  };

  return (
    <>
      <Table
        dataSource={documents}
        columns={[
          {
            name: 'Type',
            cell: (row: ProvidedDocuments) => row.type,
          },
          {
            name: 'Reference number',
            cell: (row: ProvidedDocuments) => row.referenceNumber || '',
          },
          {
            name: 'Description',
            cell: (row: ProvidedDocuments) => row.description,
            width: 300,
          },
          {
            name: 'File name',
            cell: (row: ProvidedDocuments) => row.fileName || '',
          },
        ]}
      />
      <Group justify="flex-end" mt="xs">
        <Button variant="default" onClick={onHide} ml="xs">
          Cancel
        </Button>
        <Button variant="red" onClick={handleConfirmSend} disabled={!documents.length} loading={isPending}>
          Send Documents
        </Button>
      </Group>
    </>
  );
};
